import type { GuideStep } from "../loadProjectOverviewGuideSteps";
import { REPLAY_GUIDE_KEY } from "./replayGuideStep";
import type { WelcomeDeck } from "./WelcomeDeck";

// Sorts a deck's steps on two keys, leaving every other step in its source order:
// `[...others, ending row, replay card]`. The deck's ending row (its own hand-off card) sorts
// second-to-last regardless of its priority in the source data, and the "Come back any time" replay
// card ends the tour. Both keys are optional and the pass is a no-op when neither is present: the
// ending row can have been dropped by the caller's presence filter (its anchor isn't in the DOM),
// and the replay card is dropped entirely on an on-demand replay (it is firstRunOnly). Rows for
// anchors not in the current DOM are the caller's job to drop first.
export function orderStepsForDeck(steps: GuideStep[], deck: WelcomeDeck): GuideStep[] {
  const isReplay = (step: GuideStep) => step.key === REPLAY_GUIDE_KEY;
  const isEnding = (step: GuideStep) => step.anchorId === deck.ending.anchorId && !isReplay(step);

  // Three disjoint passes over the same list, so a step can neither be duplicated nor dropped.
  return [...steps.filter((step) => !isEnding(step) && !isReplay(step)), ...steps.filter(isEnding), ...steps.filter(isReplay)];
}
